'use client'

import { TTopFAQ } from '@/entities/support'
import { Link } from '@/shared/i18n'
import { Button, Icon, Layout } from '@/shared/ui'
import { TopFAQList } from '@/widgets/faq'

type Props = {
  faqs: TTopFAQ[]
}

export const FAQ = ({ faqs }: Props) => {
  return (
    <section className="bg-gray-50">
      <Layout className="my-20">
        <h3 className="typo-title2 mb-10 text-center font-semibold text-black">
          자주 묻는 질문
        </h3>
        <TopFAQList faqs={faqs} />
        <Button
          variant="outline"
          size="large"
          color="secondary"
          fullWidth
          asChild
          className="mx-auto mt-6 flex w-[392px]"
        >
          <Link href="/host/support/faq">
            자주 묻는 질문 전체보기
            <Icon name="arrow-right" size={16} />
          </Link>
        </Button>
      </Layout>
    </section>
  )
}
